import React from "react";
import { Col, Row, Popover } from "antd";

export default function ListCard(props) {
  const formatPrice = (price) => {
    if (!price) return "R$ 0,00";

    // Remove o "R$ " se existir e converte para número
    const numericValue = parseFloat(price.toString().replace("R$ ", "").trim());

    // Formata como moeda brasileira
    return numericValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  // Função para calcular variação percentual
  const calculatePercentageChange = (minPrice, maxPrice) => {
    if (!minPrice || !maxPrice) return 0;
    const min = parseFloat(minPrice);
    const max = parseFloat(maxPrice);
    if (min === 0) return 0; // Evita divisão por zero
    const variation = ((max - min) / min) * 100;
    return variation.toFixed(2); // Retorna com 2 casas decimais
  };

  const handleFilterChange = (value) => {
    if (props.onFilterChange) {
      props.onFilterChange(value);
    }
  };

  return (
    <>
      <Row gutter={[24, 16]} className="hp-mt-24">
        <Col sm={12} span={24}>
          {props.title && (
            <span className="h3 hp-d-block hp-font-weight-700 hp-text-color-black-bg hp-text-color-dark-0">
              {props.title}
            </span>
          )}

          {props.date && (
            <span className="hp-p1-body hp-d-block hp-mt-4 hp-slashed-zero">
              {props.date}
            </span>
          )}
        </Col>
        {props.select && (
          <Col sm={12} span={24}>
            {props.select}
          </Col>
        )}
      </Row>

      {props.list && (
        <Row gutter={[24, 16]} className="hp-mt-24">
          {props.list.map((item, index) => (
            <Popover
              content={
                <div>
                  <p className="hp-mb-0">
                    Preço médio: {formatPrice(item.preco_medio)}
                  </p>
                  <p className="hp-mb-0">
                    Preço minimo: {formatPrice(item.preco_min)}
                  </p>
                  <p className="hp-mb-0">
                    Preço maximo: {formatPrice(item.preco_max)}
                  </p>
                  <p className="hp-mb-0">
                    Variação:{" "}
                    {calculatePercentageChange(item.preco_min, item.preco_max)}%
                  </p>
                </div>
              }
              title={item.title}
              trigger="hover"
            >
              <Col
                span={24}
                key={index}
                className="hp-cursor-pointer hp-transition hp-hover-bg-dark-100 hp-hover-bg-black-10 hp-border-radius hp-py-8 hp-list-aside"
              >
                <div
                  className="hp-mr-16 hp-border-1 hp-border-color-black-20 hp-bg-black-0 hp-border-radius-lg hp-d-flex-full-center"
                  style={{ minWidth: 48, height: 48 }}
                >
                  <i className="ph-light ph-shopping-cart" />
                </div>

                <Col className="hp-p-0 hp-w-100">
                  {item.title && (
                    <span className="hp-d-block hp-p1-body hp-font-weight-500 hp-text-color-black-bg hp-text-color-dark-0">
                      {item.title}
                    </span>
                  )}
                  <Row className="hp-d-flex hp-align-items-center hp-d-flex-between">
                    {item.date && (
                      <span className="hp-d-block hp-caption hp-font-weight-400 hp-text-color-black-60 hp-slashed-zero">
                        {item.date}
                      </span>
                    )}
                    {item.preco_medio && (
                      <>
                        <span className="hp-mb-0 hp-mr-4 hp-text-color-black-60 hp-input-description">
                          R$ {item.variacao}
                        </span>
                        <span className="h5 hp-font-weight-400 hp-text-color-black-b-100 hp-text-color-dark-0 hp-slashed-zero">
                          R$ {item.preco_medio}
                        </span>
                      </>
                    )}
                  </Row>
                </Col>
              </Col>
            </Popover>
          ))}
        </Row>
      )}
    </>
  );
}
